import PropTypes from 'prop-types';
import React from 'react';

import Box from '../Box';
import { useNavigationGuard } from './useNavigationGuard';
import { NavigationGuardMessage } from './NavigationGuardMessage';

import styles from './NavigationGuard.scss';

const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
};

export function NavigationGuard({ blocked, forbid, children, overlay }) {
    const { isBlocking, wasBlocking, cancel, leave } = useNavigationGuard({ blocked, forbid });

    if (!isBlocking) {
        return children;
    }

    return (
        <div className={styles.root}>
            <div className={styles.content}>{children}</div>
            <div className={styles.overlay} onClick={cancel}>
                {overlay ? (
                    overlay({ cancel, leave, wasBlocking })
                ) : (
                    <div className={styles.prompt} onClick={preventDefault}>
                        <Box className={styles.box}>
                            <NavigationGuardMessage cancel={cancel} leave={leave} />
                        </Box>
                    </div>
                )}
            </div>
        </div>
    );
}

NavigationGuard.propTypes = {
    children: PropTypes.node.isRequired,
    overlay: PropTypes.func,
    forbid: PropTypes.func,
    blocked: PropTypes.bool,
};
